<ng-container *ngIf="appSaveService.form$ | async as form">
  <ng-container
    *ngIf="
      ((form | propertyInObject : 'valid') && form.valid) || (form | appSaveValidState);
      else formValidationSummary
    "
  >
    <button
      mat-mini-fab
      [disabled]="
        (appSaveService.disableSaveButton$ | async) || (appSaveService.disableOverride$ | async)
      "
      (click)="executeFunc()"
    >
      <mat-icon>save</mat-icon>
    </button>
  </ng-container>

  <sd-save-state-notifier
    [disableState]="
      (isSaving$ | async) ||
      ((form | propertyInObject : 'valid') && (form.pristine || !form.valid)) ||
      !(form | appSaveEnabledState)
    "
  ></sd-save-state-notifier>

  <ng-template #formValidationSummary>
    <button
      mat-mini-fab
      [disabled]="
        (appSaveService.disableSaveButton$ | async) || (appSaveService.disableOverride$ | async)
      "
      (click)="runFormValidationSummary()"
    >
      <mat-icon [color]="(appSaveService.submitted$ | async) ? 'warn' : null">save</mat-icon>
    </button>
  </ng-template>
</ng-container>
